import { render, staticRenderFns } from "./ProblemTask.vue?vue&type=template&id=71ab567c"
import script from "./ProblemTask.vue?vue&type=script&lang=js"
export * from "./ProblemTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports